import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaCalendarAlt } from 'react-icons/fa';
import './Projects.css';

const Projects = () => {
  const experiences = [
    {
      company: 'ECHO Technology Solutions',
      position: 'Backend Developer',
      period: 'Mar 2025 - Jan 2026',
      description: [
        'Worked on several .NET projects',
        'Implemented ps1 scripts for large data processing',
        'Worked with Salesforce integration with .NET applications',
        'Worked with Azure deployments, App management and other Azure features',
        'Almost everything from previous experiences listed below',
      ],
      technologies: ['.NET', 'Salesforce', 'Azure', 'PowerShell', 'C#'],
    },
    {
      company: 'evoila Bosnia',
      position: 'Backend Developer',
      period: 'May 2022 - Feb 2025',
      description: [
        'Worked on several banking projects as Full Stack developer (.NET Core and Blazor)',
        'Built and maintained front-end applications using Angular, enhancing user experience with interactive components',
        'Integrated third-party services and APIs to extend functionality and improve overall application capabilities',
        'Developed and maintained server-side logic for processing and delivering real-time data feeds, ensuring high performance and scalability for banking systems',
        'Mentored junior developers',
        'Automated deployment processes and managed CI/CD pipelines to enhance efficiency and reduce time-to-market',
        'Implemented and managed message broking solutions to handle asynchronous communication and data exchange between services',
      ],
      technologies: ['.NET Core', 'Blazor', 'Angular', 'SQL Server', 'CI/CD', 'RabbitMQ'],
    },
    {
      company: 'TNT Soft',
      position: 'Backend Developer',
      period: 'Nov 2021 - Jun 2022',
      description: [
        'Developed several back-end applications from the ground up using .NET Core and C#',
        'Created RESTful APIs with scalable architecture',
        'Configured the project structure and application architecture',
        'Developed and maintained server-side logic for processing and delivering real-time data feeds, ensuring high performance and scalability',
      ],
      technologies: ['.NET Core', 'C#', 'RESTful APIs', 'PostgreSQL'],
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section id="projects" className="projects">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Work Experience</h2>
          <p className="section-subtitle">
            My professional journey and the companies I've worked with
          </p>
        </motion.div>

        <motion.div
          className="projects-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {experiences.map((experience, index) => (
            <motion.div
              key={index}
              className="project-card"
              variants={itemVariants}
              whileHover={{ y: -10 }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <div className="project-content">
                <div className="experience-header">
                  <div className="experience-icon">
                    <FaBriefcase />
                  </div>
                  <div>
                    <h3 className="project-title">{experience.company}</h3>
                    <p className="experience-position">{experience.position}</p>
                    <div className="experience-period">
                      <FaCalendarAlt /> {experience.period}
                    </div>
                  </div>
                </div>
                <ul className="experience-description">
                  {experience.description.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
                <div className="project-technologies">
                  {experience.technologies.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
